<div class="counter-flex">
  <textarea #textarea [style.overflow-x]="setHorizontalScrollPolicy()" [style.overflow-y]="setVerticalScrollPolicy()"
    class="text-label-required" [style.background-color]="bg"
    [tabindex]="tabEnabled ? tabindex : -1"
    [disabled]="disabled" [readonly]="!editable" [maxlength]="maxChars" [(ngModel)]="text" autocomplete="off"
    (ngModelChange)="onChange($event);textChanged()" plessInputTextSub [restrict]="restrict" [fullOnly]="fullOnly" [halfOnly]="halfOnly"
    [allowMultiLine]="allowMultiLine"
    [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
    [style.height.px]="height" [style.height]="height !== undefined ? height : null"
    (blur)="onFocusOut();onTouched();blur.emit($event)" (focus)="onFocusIn()"></textarea>
  <label style="padding-left:8px;" *ngIf="displayCountField" [style.width]="counterWidth">{{ count }}</label>
</div>
